import config from "config";
import Amplify, { Hub as AmplifyHub, Auth as CognitoAuth } from "aws-amplify";
import BaseAuthDriver from "./BaseAuthDriver";

class CognitoAuthDriver extends BaseAuthDriver {
  static init() {
    const { host, protocol } = window.location;
    const baseUrl = `${protocol}//${host}`;

    let amplifyConfig, authConfig;

    switch (config("aws.cognito.authType")) {
      case "userpool":
        amplifyConfig = {
          Auth: {
            region: config("aws.cognito.region"),
            userPoolId: config("aws.cognito.userPool.id"),
            userPoolWebClientId: config("aws.cognito.userPool.clientId")
          },

          Analytics: {
            disabled: true
          },

          // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
          authenticationFlowType: config("aws.cognito.flowType")
        };

        authConfig = {
          oauth: {
            domain: config("aws.cognito.domain"),
            scope: ["profile", "openid"],
            redirectSignIn: `${baseUrl}/auth/cognito`,
            redirectSignOut: `${baseUrl}/logout`,
            responseType: "code"
          }
        };
        break;
      default:
        throw new Error("Unsupported AWS Cognito Auth Type");
    }

    Amplify.configure(amplifyConfig);
    CognitoAuth.configure(authConfig);

    return new CognitoAuthDriver();
  }

  getCurrentUser() {
    return new Promise((resolve, reject) => {
      Promise.all([
        CognitoAuth.currentAuthenticatedUser(),
        CognitoAuth.currentSession()
      ])
        .then((data) =>
          resolve({
            user: data[0],
            session: data[1]
          })
        )
        .catch((error) => reject(error));
    });
  }

  isCurrentUserAuthorizedTo(action) {
    return new Promise((resolve, reject) => {
      if (this.isUserLoggedIn()) {
        resolve(true);
      } else {
        reject("User is not authorized");
      }
    });
  }

  isUserLoggedIn() {
    return new Promise((resolve, reject) => {
      this.getCurrentUser()
        .then((userData) => {
          resolve(!!userData);
        })
        .catch((error) => {
          console.debug(error);
          resolve(false);
        });
    });
  }

  usesExternalFlow() {
    return true;
  }

  handleExternalFlow() {
    return new Promise((resolve, reject) => {
      AmplifyHub.listen("auth", (event) => {
        if (event.payload.event === "signIn") {
          resolve(event.payload);
        } else {
          reject(new Error(event.payload.event));
        }
      });
    });
  }

  attemptLogin() {
    return CognitoAuth.federatedSignIn();
  }

  logout() {
    return CognitoAuth.signOut();
  }
}

export default CognitoAuthDriver;
